import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { SmartPowerSettingsDto, SmartPowerSettingsUpdateDto } from 'src/Libs/smart-power/api/dto'
import { SmartPowerSettingsModel } from 'src/Libs/smart-power/models'
import { fromDtoToModel } from 'src/Libs/smart-power/transformers'
import { handleFetchError } from 'src/Libs/api/utils'

export const getSettings = async (
  serialNumber: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<SmartPowerSettingsModel>> => {
  try {
    const response = await authFetch<SmartPowerSettingsDto>({
      path: `storages/${serialNumber}/smart-functions/smart-power`,
      method: 'GET',
      payload: undefined,
    })

    if (response.status === StatusCodes.OK) {
      const model = fromDtoToModel(response.data)
      return new ApiResult<SmartPowerSettingsModel>(model)
    }
    if (response.status === StatusCodes.NO_CONTENT) return new ApiResult<SmartPowerSettingsModel>(null, true)
    throw new UnexpectedApiResponseError(response.status)
  } catch (error) {
    return handleFetchError<SmartPowerSettingsModel>(error)
  }
}

export const updateSettings = async (
  serialNumber: string | undefined,
  model: SmartPowerSettingsUpdateDto,
  authFetch: AuthFetchWithResponse
): Promise<void> => {
  const response = await authFetch<void>({
    path: `storages/${serialNumber}/smart-functions/smart-power`,
    method: 'PUT',
    payload: JSON.stringify(model),
  })
  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }
}
